import { BUDGET_EDIT, BUDGET_VIEW } from '@/fixtures'

export default {
  path: 'budget-plan',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Budget/Plan',
      component: () => import('@/views/menus/BudgetPlan/Index'),
      meta: {
        permission: BUDGET_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Budget/Plan',
      component: () => import('@/views/menus/BudgetPlan/View'),
      meta: {
        permission: BUDGET_VIEW
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Budget/Plan',
      component: () => import('@/views/menus/BudgetPlan/Edit'),
      meta: {
        permission: BUDGET_EDIT
      }
    }
  ]
}
